// Office sidebar expanded-group state (Session AI Item 8). The set of nav-group labels the
// user has expanded is held in sessionStorage, NOT on the server and NOT in localStorage:
// the brief is that every section starts collapsed on each new login and the user opens what
// they need, with the choice persisting only for the browser session (sessionStorage clears
// when the tab closes) and reset explicitly on logout. localStorage would wrongly persist the
// open groups across logins. All three helpers are SSR/quota safe (try/catch, window guard).
const NAV_EXPANDED_KEY = "ele:nav-expanded";

export function loadNavExpanded(): Set<string> {
  if (typeof window === "undefined" || !window.sessionStorage) return new Set();
  try {
    const raw = window.sessionStorage.getItem(NAV_EXPANDED_KEY);
    const parsed = raw ? (JSON.parse(raw) as unknown) : [];
    return new Set(Array.isArray(parsed) ? parsed.filter((x): x is string => typeof x === "string") : []);
  } catch {
    return new Set();
  }
}

// True once the person (or the active-group auto-open) has stored an expanded-group choice in this
// browser session. SC7A: with no stored choice the calm menu's four groups all start open.
export function hasStoredNavExpanded(): boolean {
  if (typeof window === "undefined" || !window.sessionStorage) return false;
  try {
    return window.sessionStorage.getItem(NAV_EXPANDED_KEY) !== null;
  } catch {
    return false;
  }
}

export function saveNavExpanded(labels: ReadonlySet<string>): void {
  if (typeof window === "undefined" || !window.sessionStorage) return;
  try {
    window.sessionStorage.setItem(NAV_EXPANDED_KEY, JSON.stringify([...labels]));
  } catch {
    // ignore quota / availability errors -- the open/closed state is non-critical
  }
}

// Reset every group to collapsed (called on logout, so the next login starts clean).
export function clearNavExpanded(): void {
  if (typeof window === "undefined" || !window.sessionStorage) return;
  try {
    window.sessionStorage.removeItem(NAV_EXPANDED_KEY);
  } catch {
    // ignore
  }
}
